export const getEscopoGases = (state) => state.escopoGases.lista
export const getTotalEscopoGases = (state) => state.escopoGases.total
export const getIsCarregandoListaEscopoGases = (state) => state.escopoGases.isCarregandoLista
